import {
  Box
} from "@primer/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { lichSuXuongPhongYTeApi } from "../../../api/lichSuXuongPhongYTeApi";
import DataTable from "../../../components/ui/data-table";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import { ILichSuXuongPhongYTe } from "../../../models/response/crm-hocsinh/ILichSuXuongPhongYTe";

interface LichSuXuongPhongYTeProps {
  hocSinhId: number;
}

const LichSuXuongPhongYTePage: React.FC<LichSuXuongPhongYTeProps> = ({ hocSinhId }) => {
  const { nam_hoc } = useCommonSelectedHook();
  const [namHocSelected, setNamHocSelected] = useState<string>("");
  const [listXuongPhongYTe, setListXuongPhongYTe] = useState<ILichSuXuongPhongYTe[]>([]);

  useEffect(() => {
    setNamHocSelected(nam_hoc);
  }, [nam_hoc]);

  useEffect(() => {
    if (namHocSelected && hocSinhId) {
      getLLichSuXuongPhongYTe();
    }
  }, [namHocSelected, hocSinhId]);

  const getLLichSuXuongPhongYTe = async () => {
    try {
      const res = await lichSuXuongPhongYTeApi.selectByHocSinh(
          hocSinhId
        );
      if (res.is_success && res.data) {
        setListXuongPhongYTe(res.data);
      } else {
        setListXuongPhongYTe([]);
      }
    } catch (error) {
      console.error("Error fetching mien giam list:", error);
      setListXuongPhongYTe([]);
    }
  };

  return (
    <Box sx={{ paddingTop: 15 }}>
      <DataTable
        height={`${window.innerHeight - 200}px`}
        actionComponent={
          <Box
            sx={{
              display: "flex",
              gap: 2,
            }}
          >
          
          </Box>
        }
        columns={[
          {
            dataField: "trang_thai",
            width: "auto",
            caption: `Trạng thái`,
            isMainColumn: true,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.trang_thai || ""}
                </Box>
              );
            },
          },
          {
            dataField: "ma_hs",
            width: "auto",
            caption: `Mã học sinh`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.ma_hs || ""}
                </Box>
              );
            },
          },
          {
            dataField: "ten_hoc_sinh",
            width: "auto",
            caption: `Tên học sinh`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.ten_hoc_sinh || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "tinh_trang",
            width: "auto",
            caption: `Tình trạng`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.tinh_trang || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "ngay_tao",
            width: "auto",
            caption: `Ngày tạo`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {moment(data.ngay_tao).format("DD/MM/YYYY")  || ""}
                </Box>
              );
            },
          },
          {
            dataField: "ngay_cap_nhat",
            width: "auto",
            caption: `Ngày sửa`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {moment(data.ngay_cap_nhat).format("DD/MM/YYYY") || ""}
                </Box>
              );
            },
          },
          {
            dataField: "nguoi_tao",
            width: "auto",
            caption: `Người tạo`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.nguoi_tao || ""}
                </Box>
              );
            },
          },
        ]}
        data={listXuongPhongYTe}
        title="Lịch sử xuống phòng y tế"
        searchEnable
      />
    </Box>
  );
};

export default LichSuXuongPhongYTePage;
